import { ACTIONS_TYPES } from "../utils/constants";

export const initialState = {
  companies: [],
  error: null,
  loader: false,

  companyDetails: null,
  registerCompanyErrors: null,
  registerCompanyLoader: false,
  registerCompanySuccess: false,

  suspendCompanyDetails: {},
  suspendCompanyErrors: null,
  suspendCompanySuccess: false,
  suspendCompanyLoader: false,
};

export default function companyReducer(state = initialState, action) {
  switch (action.type) {
    case ACTIONS_TYPES.FETCH_COMPANIES_REQUEST:
      return { ...state, loader: true, errors: null };

    case ACTIONS_TYPES.FETCH_COMPANIES_SUCCESS:
      return { ...state, companies: action.payload, loader: false };

    case ACTIONS_TYPES.FETCH_COMPANIES_FAILED:
      return { ...state, loader: false, errors: action.payload };
    
    case ACTIONS_TYPES.REGISTER_COMPANY_REQUEST:
      return { ...state, registerCompanyLoader: true, registerCompanyErrors: null, registerCompanySuccess: false };

    case ACTIONS_TYPES.REGISTER_COMPANY_SUCCESS:
      return { ...state, companyDetails: action.payload, registerCompanyLoader: false, registerCompanySuccess: true };

    case ACTIONS_TYPES.REGISTER_COMPANY_FAILED:
      return { ...state, registerCompanyLoader: false, registerCompanyErrors: action.payload };
      
    case ACTIONS_TYPES.SUSPEND_COMPANY_REQUEST:
      return { ...state, suspendCompanyLoader: true, suspendCompanyErrors: null, suspendCompanySuccess: false };

    case ACTIONS_TYPES.SUSPEND_COMPANY_SUCCESS:
      return { ...state, suspendCompanyDetails: action.payload, suspendCompanyLoader: false, suspendCompanySuccess: true };

    case ACTIONS_TYPES.SUSPEND_COMPANY_FAILED:
      return { ...state, suspendCompanyLoader: false, suspendCompanyErrors: action.payload };

    case ACTIONS_TYPES.REGISTER_COMPANY_RESET:
      return { initialState }

    case ACTIONS_TYPES.SUSPEND_COMPANY_RESET:
      return { ...state,  suspendCompanyErrors: null, suspendCompanySuccess: false };
      
    case ACTIONS_TYPES.LOGOUT_REQUEST:
      return { ...initialState  };

    default:
      return state;
  }
  
}